export enum FlowStatus {
  CITIZENSHIP,
  LANDING,
  MOBILE,
  AGREEMENT,
  PHONE,
  CODE,
  CODEERROR,
  IDTYPE,
  IDFRONTHOWTO,
  IDFRONT,
  IDBACKHOWTO,
  IDBACK,
  IDTILTHOWTO,
  IDTILT,
  LIVENESSHOWTO,
  LIVENESS,
  LIVENESSGESTUREHOWTO,
  LIVENESSGESTURE,
  COMPLETE,
  ERROREND,
  CAMERAERROR,
  ABORTED,
  NONE,
  RANDOM
}

export interface FlowResult {
  state: string;
}
